



















import { defineComponent, ref } from '@nuxtjs/composition-api';
import useUiState from '@shared/composables/useUiState';
import { BaseModal, UCIcon } from '@shared/ui';
import { useUserAddresses } from '@unified-commerce/gpc-vue-storefront-shopify';

import AddressBlock from '~/components/Account/AddressBlock.vue';

export default defineComponent({
  name: 'RemoveAddressModal',
  components: { AddressBlock, BaseModal, UCIcon },
  setup() {
    const { isRemoveAddressModalOpen, toggleRemoveAddressModal, addressToRemove } = useUiState();
    const { loadUserAddresses, removeUserAddress } = useUserAddresses();
    const isConfirming = ref(false);

    const confirmRemove = async () => {
      isConfirming.value = true;
      await removeUserAddress(addressToRemove.value.id);
      toggleRemoveAddressModal();
      await loadUserAddresses();
    };

    return {
      isRemoveAddressModalOpen,
      addressToRemove,
      isConfirming,
      confirmRemove,
      toggleRemoveAddressModal,
    };
  },
});
